import { X_CAPABILITY } from './x.js';
import { PINTEREST_CAPABILITY } from './pinterest.js';

// ---------------------------------------------------------------------------
// The media upload endpoint (apps/worker/src/media/upload.ts's mint and PUT
// routes, and the `request_media_upload` MCP tool) mints an asset from a bare
// `projectId` -- no platform is chosen yet, and none of the three callers can
// name one. Judging every upload against a single platform's capability
// profile would be wrong in whichever direction that platform's limits sit:
// too strict for a platform with a larger allowance (a 6MB JPEG a Pin can
// carry, rejected because X's 5MB cap was checked instead), or too loose for
// one with a smaller allowance (nothing stops that today, since only X's
// profile has ever been consulted here).
//
// `UPLOAD_CAPABILITY` is the union across every registered capability
// profile's media limits -- the widest byte cap, the union of accepted mime
// types -- so upload rejects only what no platform could ever use. The real,
// platform-specific ceiling is enforced once the platform IS known: see
// `packages/application/src/campaigns/validate-variant.ts`, which resolves
// `profileFor(variant.platform)` and checks the attached media's actual
// bytes/mime type against that specific profile.
// ---------------------------------------------------------------------------
export const UPLOAD_CAPABILITY: { readonly maxBytes: number; readonly mimeTypes: readonly string[] } = {
  maxBytes: Math.max(X_CAPABILITY.media.maxBytes, PINTEREST_CAPABILITY.image.maxBytes),
  mimeTypes: Array.from(new Set([...X_CAPABILITY.media.mimeTypes, ...PINTEREST_CAPABILITY.image.mimeTypes])),
};
